export enum CryptoAccountWithdrawStatus {
  CREATED = 'CREATED',
  QUEUED = 'QUEUED',
  PENDING = 'PENDING',
  CONFIRMED = 'CONFIRMED',
  FAILED = 'FAILED',
  TRANSFERED = 'TRANSFERED'
}

export enum CryptoAccountWithdrawFailedReason {
  NOT_ENOUGH_BALANCE = 'NOT_ENOUGH_BALANCE',
  BALANCE_NOT_FOUND = 'BALANCE_NOT_FOUND',
  WITHDRAW_FEE_LESS_THAN_ESTIMATED = 'WITHDRAW_FEE_LESS_THAN_ESTIMATED',
  REVERTED = 'REVERTED',
  CRYPTO_ACCOUNT_NOT_FOUND = 'CRYPTO_ACCOUNT_NOT_FOUND'
}
